import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Trash2, AlertTriangle } from 'lucide-react';

export const DangerZoneSection = ({ 
  showDeleteModal, 
  setShowDeleteModal, 
  deleteConfirmText,
  setDeleteConfirmText,
  deletePassword,
  setDeletePassword,
  onDeleteAccount,
  deleting,
  userEmail
}) => {
  return (
    <div className="bg-red-50/50 backdrop-blur-md border border-red-100 shadow-lg rounded-2xl p-8">
      <div className="flex items-center space-x-3 mb-6">
        <Trash2 className="w-6 h-6 text-red-500" strokeWidth={1.5} />
        <h2
          className="text-2xl font-medium text-red-700"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Danger Zone
        </h2>
      </div>
      
      <p className="text-stone-600 mb-6">
        Permanently delete your account and all associated data. This action cannot be undone.
      </p>
      
      {!showDeleteModal ? (
        <Button
          onClick={() => setShowDeleteModal(true)}
          variant="outline"
          className="rounded-full px-6 border-red-300 text-red-600 hover:bg-red-50"
          data-testid="show-delete-modal"
        >
          <Trash2 className="w-4 h-4 mr-2" />
          Delete Account
        </Button>
      ) : (
        <div className="space-y-4 p-4 bg-white/80 rounded-xl border border-red-200">
          <div className="flex items-center gap-2 text-red-600 text-sm">
            <AlertTriangle className="w-4 h-4" />
            <span>This will permanently delete all your data</span>
          </div>
          
          <div>
            <label className="text-sm text-stone-600 mb-1 block">
              Type "DELETE" to confirm
            </label>
            <Input
              value={deleteConfirmText}
              onChange={(e) => setDeleteConfirmText(e.target.value)}
              placeholder="DELETE"
              className="font-mono"
              data-testid="delete-confirm-text"
            />
          </div>
          
          <div>
            <label className="text-sm text-stone-600 mb-1 block">
              Enter your password
            </label>
            <Input
              type="password"
              value={deletePassword}
              onChange={(e) => setDeletePassword(e.target.value)}
              placeholder="Your password"
              data-testid="delete-password"
            />
          </div>
          
          <div className="flex gap-2">
            <Button
              onClick={() => {
                setShowDeleteModal(false);
                setDeleteConfirmText('');
                setDeletePassword('');
              }}
              variant="outline"
              className="flex-1 rounded-full"
            >
              Cancel
            </Button>
            <Button
              onClick={onDeleteAccount}
              disabled={deleting || deleteConfirmText !== 'DELETE' || !deletePassword}
              className="flex-1 rounded-full bg-red-600 hover:bg-red-700 text-[#1A1A2E]"
              data-testid="confirm-delete-account"
            >
              {deleting ? 'Deleting...' : 'Delete Forever'}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
